// extracted by mini-css-extract-plugin
export var aboutMeBox = "aboutMeContainer-module--aboutMeBox---XNSu";
export var aboutMeText = "aboutMeContainer-module--aboutMeText--vAnU0";
export var sbu = "aboutMeContainer-module--sbu--f1SKb";
export var text = "aboutMeContainer-module--text---NDdK";
export var textContainer = "aboutMeContainer-module--textContainer--OpOpT";